import React, { useState } from 'react';
import { MapPin, Check, X } from 'lucide-react';
import { motion } from 'framer-motion';
import UberLocationPicker from '../UberLocationPicker';

import { useTranslation } from 'react-i18next';

const LocationPickerCard = ({ label, onSelect, initialValue }: any) => {
  const { t } = useTranslation();
  const [selectedLocation, setSelectedLocation] = useState(initialValue || null);
  const [isOpen, setIsOpen] = useState(false);

  const handleLocationSelect = (location: any) => {
    setSelectedLocation(location);
    setIsOpen(false);
    onSelect(location);
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      className="mb-4"
    >
      <div className="relative group">
        {/* Gradient border effect */}
        <div className="absolute -inset-0.5 bg-gradient-to-r from-purple-600 to-pink-600 rounded-2xl blur opacity-30 group-hover:opacity-50 transition duration-300"></div>
        
        <div className="relative bg-background dark:bg-slate-800 rounded-2xl p-4 border border-border dark:border-slate-700">
          <div className="flex items-center justify-between mb-3">
            <div className="flex items-center space-x-2">
              <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-purple-500 to-pink-500 flex items-center justify-center">
                <MapPin size={20} className="text-white" />
              </div>
              <div>
                <h4 className="font-semibold text-foreground dark:text-slate-200">{label}</h4>
                <p className="text-xs text-muted-foreground">{t('auto.klikk_for_velge_adresse', 'Click to select address')}</p>
              </div>
            </div>
            {selectedLocation && (
              <div className="w-8 h-8 rounded-full bg-green-100 dark:bg-green-900/30 flex items-center justify-center">
                <Check size={16} className="text-green-600 dark:text-green-400" />
              </div>
            )}
          </div>

          {selectedLocation ? (
            <div className="bg-muted/50 dark:bg-slate-900/50 rounded-xl p-3">
              <p className="text-sm font-medium text-foreground dark:text-slate-300">{selectedLocation}</p>
              <button
                onClick={() => setIsOpen(true)}
                className="text-xs text-purple-600 dark:text-purple-400 hover:underline mt-1"
              >
                Change address
              </button>
            </div>
          ) : (
            <button
              onClick={() => setIsOpen(true)}
              className="w-full py-3 px-4 bg-gradient-to-r from-purple-600 to-pink-600 text-white rounded-xl font-medium hover:shadow-lg hover:shadow-purple-500/50 transition-all duration-300"
            >
              Select address
            </button>
          )}
        </div>
      </div>

      {/* UberLocationPicker Modal */}
      <UberLocationPicker
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onSelect={handleLocationSelect}
        title={label}
      />
    </motion.div>
  );
};

export default LocationPickerCard;
